import {getSupportedLocalesAndAlias, type LocaleEnum} from '../types/locale';

/**
 * Validates if the given locale is part of the supported locales.
 *
 * @param string $locale The locale to validate.
 *
 * @throws Error If the locale is not supported.
 */
export const validateLocale = (locale: LocaleEnum) => {
  const supportedLocale: string = getSupportedLocalesAndAlias().locales.find(supportedLocale => supportedLocale == locale);
  if (!supportedLocale) {
    throw new Error(`Locale is not supported: ${locale}`);
  }
};
